const content = [
  // 第一章 第七节 Self-Regulated Learning
  // 小标题
  {
    key: 'section8',
    type: "title",
    category: 7, // *必填* 分类 1：章头 2：节头 3：小标题 ...
    // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
    text: "Chinese Wisdom", // *必填* 标题文本内容
    titleImage: require("@/assets/images/books/book2/title-back.png"),
    textStyle: {
      // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
      fontSize: 38, // 文字大小  默认：26
      // lineHeight: 40, // 行高  默认：46
      textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
      // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
      // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
      // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
      // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
      color: '#5CA683', // 文本颜色  默认：#00a8ac
      // backgroundColor: '#FFF', // 背景颜色  默认：无
      // backgroundImage: require("@/assets/images/bookContent/chapter_title_bg.png") // 背景图片  默认：无
      marginTop: 24,
    },
  },
  // 模板样式 单个带边框
  {
    key: 'section8.1',
    type: 'template',
    category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
    templateStyle: {
      // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
      // fontSize: 38, // 文字大小  默认：26
      // lineHeight: 40, // 行高  默认：46
      // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
      // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
      // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
      // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
      // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
      // color: '#5CA683', // 文本颜色  默认：#00a8ac
      // backgroundColor: '#FFF', // 背景颜色  默认：无
      marginTop: 30,
      marginBottom: 30,
      padding: 20,
      backgroundColor: '#FFFFFF',
      // paddingTop: 0,
      // paddingBottom: 0,
      borderRadius: 0,
    },
    content: [
      {
        key: 'section8.1.1',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: "Chinese Festivals", // *必填* 标题文本内容
        textStyle: {
          fontFamily: 'Arial', // 字体，本地配置的字体
          fontSize: 32, // 文字大小  默认：26
          lineHeight: 36, // 行高  默认：46
          textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
          // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
          // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
          // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
          textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
          color: '#333333', // 文本颜色  默认：#00a8ac
          // backgroundColor: '#FFF', // 背景颜色  默认：无
          // backgroundImage: require("@/assets/images/bookContent/chapter_title_bg.png") // 背景图片  默认：无
          marginTop: 10,
        },
      },
      {
        key: 'section8.1.2', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        isInTable: true,
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
          {
            key: 'section8.1.2.1', // *必填* 唯一标识
            category: 'text', // *必填* 内容类型 text：文本
            text: ' Read the introduction to Chinese festivals and think about the information you know about these festivals. Share your ideas with your classmates.', // *必填* 文本内容
            textStyle: {},
          }
        ],
        textStyle: {
          fontFamily: 'Calibri', // 字体，本地配置的字体
          fontSize: 28, // 文字大小  默认：20
          lineHeight: 42, // 行高  默认：36
          textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
          // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
          // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
          fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
          // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
          color: '#333', // 文本颜色  默认：#00a8ac
          // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
      },
      // 音频
      {
        key: 'section8.1.3', // *必填* 唯一标识
        type: 'audio', // *必填* 类型：视频
        templateType: 1, // *必填* 板式 1：全部显示-平铺 2：两个并列-平铺 3：视频集 4：左右滑动
        playerInline: 1, // 是否是行内播放 1：行内播放
        styleType: 1, // 使用的样式 1：机械制图中使用的样式 默认为封面+标题
        content: [ // *必填* 视频列表
          {
            key: 'section8.1.3.1', // *必填* 唯一标识
            url: require("@/assets/audio/2-7/ChineseFestivals.mp3"), // *必填* 视频地
            title: 'Chinese Festivals', // 视频标题
            subtitle: 'Dialogue', // 视频副标题 只在全部显示时使用
            contentStyle: {
              width: '100%',
              marginTop: 30,
              marginBottom: 30,
            },
          },
        ],
      },
      //展开收起title
      {
        key: 'section8.1.4',
        type: 'template',
        category: 3, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
        templateStyle: {
          margin: 0,
        },
        title: '参考翻译',
        titleStyle: {
          fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
          fontSize: 26, // 文字大小  默认：26
          // lineHeight: 40, // 行高  默认：46
          // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
          // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
          // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
          // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
          // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
          // color: '#5CA683', // 文本颜色  默认：#00a8ac
          // backgroundColor: '#FFF', // 背景颜色  默认：无
          // marginTop: 30,
          // marginBottom: 30,
          // padding: 0,
          // paddingTop: 0,
          // paddingBottom: 0,
          // borderRadius: 0,
          // border: '',
          // borderTop: '',
          // borderBottom: ''
        },
        content: [{
          key: 'section8.1.4.1', // *必填* 唯一标识
          type: 'text', // *必填* 类型：正文
          isInTable: true,
          content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
              key: 'section8.1.4.1.1', // *必填* 唯一标识
              category: 'text', // *必填* 内容类型 text：文本
              text: '中国有着五千多年的悠久历史，文化底蕴深厚，传统节日丰富多彩。这些独特有趣的节日习俗淋漓尽致地呈现了古代生活的绚烂多彩。中国传统节日大多是在秦朝（公元前221—206 年）形成的，我们至今盛大庆祝的主要节日则是在汉朝（公元前 206 年—公元 220 年）时期确定的。中国的传统节日是根据中国农历来庆祝的 ；因此，各个节日的公历日期每年都有所不同。不过，所有节日都可以表达对幸福、健康、好运、财富及阖家团圆的美好祝愿。', // *必填* 文本内容
              textStyle: {
                fontFamily: 'STXihei', // 字体，本地配置的字体
                // fontWeight: 'bold'
              },
            },
          ],
          textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            fontSize: 26, // 文字大小  默认：20
            lineHeight: 42, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#111', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            marginTop: 20,
          },
        },
        {
          key: 'section8.1.4.2', // *必填* 唯一标识
          type: 'text', // *必填* 类型：正文
          isInTable: true,
          content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
              key: 'section8.1.4.2.1', // *必填* 唯一标识
              category: 'text', // *必填* 内容类型 text：文本
              text: '在中国，举国同庆的传统节日主要有 8 个，分别是春节、元宵节、清明节、端午节、乞巧节、中元节、中秋节和重阳节。不同地区也会庆祝一些其他节日，如腊八节、冬至等。此外，不同民族也有独特的节日，如彝族的火把节、苗族的芦笙节、傣族的泼水节等。', // *必填* 文本内容
              textStyle: {
                fontFamily: 'STXihei', // 字体，本地配置的字体
                // fontWeight: '400'
              },
            },
          ],
          textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            fontSize: 26, // 文字大小  默认：20
            lineHeight: 42, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            marginBottom: 20,
          },
        }],
        contentStyle: {
          // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
          // fontSize: 38, // 文字大小  默认：26
          // lineHeight: 40, // 行高  默认：46
          // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
          // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
          // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
          // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
          // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
          // color: '#5CA683', // 文本颜色  默认：#00a8ac
          // backgroundColor: '#FFF', // 背景颜色  默认：无
          // marginTop: 30,
          // marginBottom: 30,
          padding: 20,
          paddingTop: 0,
          paddingBottom: 0,
          // borderRadius: 0,
          // border: '',
          // borderTop: '',
          // borderBottom: ''
        },
      },
      {
        key: 'section8.1.5', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        isInTable: true,
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
          {
            key: 'section8.1.5.1', // *必填* 唯一标识
            category: 'text', // *必填* 内容类型 text：文本
            text: 'With its long history of over 5,000 years, China boasts a ', // *必填* 文本内容
            textStyle: {},
          },
          {
            key: 'section8.1.5.2', // *必填* 唯一标识
            category: 'popover', // *必填* 内容类型 text：文本
            text: 'profound', // *必填* 文本内容
            popTitle: '',
            popText: '',
            popWord: true,
            isPlay: false,
            word_url: require('@/assets/audio/2-7/01 profound.mp3'), // 单词音频,
            popWordTitle: [
              {
                key: 'section8.1.5.2.1',
                text: 'profound',
                textStyle: {
                  fontFamily: 'Arial',
                  fontWeight: 'bold',
                  color: '#333',
                  // fontSize: 18,
                }
              },
              {
                key: 'section8.1.5.2.2',
                text: '/prəˈfaʊnd/',
                textStyle: {
                  fontFamily: 'Calibri',
                  color: '#999999',
                  // fontSize: 14,
                }
              }
            ],
            popWordList: [
              {
                key: 'section8.1.5.2.3',
                text: '释义',
                textStyle: {
                  fontFamily: 'STXihei',
                  color: '#333',
                  // fontSize: 14
                },
                content: [
                  {
                    key: 'section8.1.5.2.3.1',
                    text: '',
                    // textFlex:true,
                    textStyle: {
                    },
                    content: [
                      // 
                      {
                        key: 'section8.1.5.2.3.1.1',
                        text: 'adj. ',
                        textStyle: {
                          fontFamily: 'Calibri',
                          color: '#333',
                          fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                          // fontSize: 13,
                          // lineHeight: 36
                        },
                      },
                      {
                        key: 'section8.1.5.2.3.1.2',
                        text: 'felt or experienced very strongly or in an extreme way; showing a clear and deep understanding of serious matters  ',
                        textStyle: {
                          fontFamily: 'Calibri',
                          color: '#333',
                          // fontSize: 13,
                          // lineHeight: 36
                        },
                      },
                      {
                        key: 'section8.1.5.2.3.1.3',
                        text: '巨大的；深切的；深远的；知识渊博的',
                        textStyle: {
                          fontFamily: 'STXihei',
                          color: '#333',
                          // fontSize: 13,
                          // lineHeight: 36,
                        },
                      },
                    ]
                  },
                ]
              },
            ],
            textStyle: {
              fontFamily: 'Calibri', // 字体，本地配置的字体
            },
          },
          {
            key: 'section8.1.5.3', // *必填* 唯一标识
            category: 'text', // *必填* 内容类型 text：文本
            text: ' culture with rich and ', // *必填* 文本内容
            textStyle: {},
          },
          {
            key: 'section8.1.5.4', // *必填* 唯一标识
            category: 'popover', // *必填* 内容类型 text：文本
            text: 'diverse', // *必填* 文本内容
            popTitle: '',
            popText: '',
            popWord: true,
            isPlay: false,
            word_url: require('@/assets/audio/2-7/02 diverse.mp3'), // 单词音频,
            popWordTitle: [
              {
                key: 'section8.1.5.4.1',
                text: 'diverse',
                textStyle: {
                  fontFamily: 'Arial',
                  fontWeight: 'bold',
                  color: '#333',
                  // fontSize: 18,
                }
              },
              {
                key: 'section8.1.5.4.2',
                text: '/daɪˈvɜ:s/',
                textStyle: {
                  fontFamily: 'Calibri',
                  color: '#999999',
                  // fontSize: 14,
                }
              }
            ],
            popWordList: [
              {
                key: 'section8.1.5.4.3',
                text: '释义',
                textStyle: {
                  fontFamily: 'STXihei',
                  color: '#333',
                  // fontSize: 14
                },
                content: [
                  {
                    key: 'section8.1.5.4.3.1',
                    text: '',
                    // textFlex:true,
                    textStyle: {
                    },
                    content: [
                      // 
                      {
                        key: 'section8.1.5.4.3.1.1',
                        text: 'adj. ',
                        textStyle: {
                          fontFamily: 'Calibri',
                          color: '#333',
                          fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                          // fontSize: 13,
                          // lineHeight: 36
                        },
                      },
                      {
                        key: 'section8.1.5.2.4.1.2',
                        text: ' including many different types of people or things  ',
                        textStyle: {
                          fontFamily: 'Calibri',
                          color: '#333',
                          // fontSize: 13,
                          // lineHeight: 36
                        },
                      },
                      {
                        key: 'section8.1.5.2.4.1.3',
                        text: '多种多样的，形形色色的',
                        textStyle: {
                          fontFamily: 'STXihei',
                          color: '#333',
                          // fontSize: 13,
                          // lineHeight: 36,
                        },
                      },
                    ]
                  },
                ]
              },
            ],
            textStyle: {
              fontFamily: 'Calibri', // 字体，本地配置的字体
            },
          },
          {
            key: 'section8.1.5.5', // *必填* 唯一标识
            category: 'text', // *必填* 内容类型 text：文本
            text: ' traditional festivals. These festivals have ', // *必填* 文本内容
            textStyle: {},
          },
          {
            key: 'section8.1.5.6', // *必填* 唯一标识
            category: 'popover', // *必填* 内容类型 text：文本
            text: 'unique', // *必填* 文本内容
            popTitle: '',
            popText: '',
            popWord: true,
            isPlay: false,
            word_url: require('@/assets/audio/2-7/03 unique.mp3'), // 单词音频,
            popWordTitle: [
              {
                key: 'section8.1.5.6.1',
                text: 'unique',
                textStyle: {
                  fontFamily: 'Arial',
                  fontWeight: 'bold',
                  color: '#333',
                  // fontSize: 18,
                }
              },
              {
                key: 'section8.1.5.6.2',
                text: '/ju:ˈni:k/',
                textStyle: {
                  fontFamily: 'Calibri',
                  color: '#999999',
                  // fontSize: 14,
                }
              }
            ],
            popWordList: [
              {
                key: 'section8.1.5.6.3',
                text: '释义',
                textStyle: {
                  fontFamily: 'STXihei',
                  color: '#333',
                  // fontSize: 14
                },
                content: [
                  {
                    key: 'section8.1.5.6.3.1',
                    text: '',
                    // textFlex:true,
                    textStyle: {
                    },
                    content: [
                      // 
                      {
                        key: 'section8.1.5.6.3.1.1',
                        text: 'adj. ',
                        textStyle: {
                          fontFamily: 'Calibri',
                          color: '#333',
                          fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                          // fontSize: 13,
                          // lineHeight: 36
                        },
                      },
                      {
                        key: 'section8.1.5.6.3.1.2',
                        text: 'being the only existing one of its type or, more generally, unusual, or special in some way  ',
                        textStyle: {
                          fontFamily: 'Calibri',
                          color: '#333',
                          // fontSize: 13,
                          // lineHeight: 36
                        },
                      },
                      {
                        key: 'section8.1.5.6.3.1.3',
                        text: '独一无二的；与众不同的；唯一的；独特的；罕见的',
                        textStyle: {
                          fontFamily: 'STXihei',
                          color: '#333',
                          // fontSize: 13,
                          // lineHeight: 36,
                        },
                      },
                    ]
                  },
                ]
              },
            ],
            textStyle: {
              fontFamily: 'Calibri', // 字体，本地配置的字体
            },
          },
          {
            key: 'section8.1.5.7', // *必填* 唯一标识
            category: 'text', // *必填* 内容类型 text：文本
            text: ' and interesting ', // *必填* 文本内容
            textStyle: {},
          },
          {
            key: 'section8.1.5.8', // *必填* 唯一标识
            category: 'popover', // *必填* 内容类型 text：文本
            text: 'customs', // *必填* 文本内容
            popTitle: '',
            popText: '',
            popWord: true,
            isPlay: false,
            word_url: require('@/assets/audio/2-7/04 custom.mp3'), // 单词音频,
            popWordTitle: [
              {
                key: 'section8.1.5.8.1',
                text: 'customs',
                textStyle: {
                  fontFamily: 'Arial',
                  fontWeight: 'bold',
                  color: '#333',
                  // fontSize: 18,
                }
              },
              {
                key: 'section8.1.5.8.2',
                text: '/ˈkʌstəm/',
                textStyle: {
                  fontFamily: 'Calibri',
                  color: '#999999',
                  // fontSize: 14,
                }
              }
            ],
            popWordList: [
              {
                key: 'section8.1.5.8.3',
                text: '释义',
                textStyle: {
                  fontFamily: 'STXihei',
                  color: '#333',
                  // fontSize: 14
                },
                content: [
                  {
                    key: 'section8.1.5.8.3.1',
                    text: '',
                    // textFlex:true,
                    textStyle: {
                    },
                    content: [
                      // 
                      {
                        key: 'section8.1.5.8.3.1.1',
                        text: 'n. ',
                        textStyle: {
                          fontFamily: 'Calibri',
                          color: '#333',
                          fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                          // fontSize: 13,
                          // lineHeight: 36
                        },
                      },
                      {
                        key: 'section8.1.5.8.3.1.2',
                        text: 'a way of behaving or a belief that has been established for a long time  ',
                        textStyle: {
                          fontFamily: 'Calibri',
                          color: '#333',
                          // fontSize: 13,
                          // lineHeight: 36
                        },
                      },
                      {
                        key: 'section8.1.5.8.3.1.3',
                        text: '风俗，习俗；传统',
                        textStyle: {
                          fontFamily: 'STXihei',
                          color: '#333',
                          // fontSize: 13,
                          // lineHeight: 36,
                        },
                      },
                    ]
                  },
                ]
              },
            ],
            textStyle: {
              fontFamily: 'Calibri', // 字体，本地配置的字体
            },
          },
          {
            key: 'section8.1.5.9', // *必填* 唯一标识
            category: 'text', // *必填* 内容类型 text：文本
            text: ', which can vividly present the ', // *必填* 文本内容
            textStyle: {},
          },
          {
            key: 'section8.1.5.10', // *必填* 唯一标识
            category: 'popover', // *必填* 内容类型 text：文本
            text: 'splendid', // *必填* 文本内容
            popTitle: '',
            popText: '',
            popWord: true,
            isPlay: false,
            word_url: require('@/assets/audio/2-7/05 splendid.mp3'), // 单词音频,
            popWordTitle: [
              {
                key: 'section8.1.5.10.1',
                text: 'splendid',
                textStyle: {
                  fontFamily: 'Arial',
                  fontWeight: 'bold',
                  color: '#333',
                  // fontSize: 18,
                }
              },
              {
                key: 'section8.1.5.10.2',
                text: '/ˈsplendɪd/',
                textStyle: {
                  fontFamily: 'Calibri',
                  color: '#999999',
                  // fontSize: 14,
                }
              }
            ],
            popWordList: [
              {
                key: 'section8.1.5.10.3',
                text: '释义',
                textStyle: {
                  fontFamily: 'STXihei',
                  color: '#333',
                  // fontSize: 14
                },
                content: [
                  {
                    key: 'section8.1.5.10.3.1',
                    text: '',
                    // textFlex:true,
                    textStyle: {
                    },
                    content: [
                      // 
                      {
                        key: 'section8.1.5.10.3.1.1',
                        text: 'adj. ',
                        textStyle: {
                          fontFamily: 'Calibri',
                          color: '#333',
                          fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                          // fontSize: 13,
                          // lineHeight: 36
                        },
                      },
                      {
                        key: 'section8.1.5.10.3.1.2',
                        text: 'excellent, or beautiful and impressive  ',
                        textStyle: {
                          fontFamily: 'Calibri',
                          color: '#333',
                          // fontSize: 13,
                          // lineHeight: 36
                        },
                      },
                      {
                        key: 'section8.1.5.10.3.1.3',
                        text: '极佳的，非常好的；华丽的；壮丽的',
                        textStyle: {
                          fontFamily: 'STXihei',
                          color: '#333',
                          // fontSize: 13,
                          // lineHeight: 36,
                        },
                      },
                    ]
                  },
                ]
              },
            ],
            textStyle: {
              fontFamily: 'Calibri', // 字体，本地配置的字体
            },
          },
          {
            key: 'section8.1.5.11', // *必填* 唯一标识
            category: 'text', // *必填* 内容类型 text：文本
            text: ' and colorful living context of the ancient period. Most traditional Chinese festivals took shape during Qin Dynasty (221–206 B.C.) and major festivals greatly celebrated today were fixed by the time of Han Dynasty (206 B.C.–220 A.D.). Chinese traditional festivals are celebrated according to the Chinese lunar calendar. Therefore, dates of each festival are varied in western calendars every year. ', // *必填* 文本内容
            textStyle: {},
          },
          {
            key: 'section8.1.5.12', // *必填* 唯一标识
            category: 'popover', // *必填* 内容类型 text：文本
            text: 'Nevertheless', // *必填* 文本内容
            popTitle: '',
            popText: '',
            popWord: true,
            isPlay: false,
            word_url: require('@/assets/audio/2-7/07 nevertheless.mp3'), // 单词音频,
            popWordTitle: [
              {
                key: 'section8.1.5.12.1',
                text: 'nevertheless',
                textStyle: {
                  fontFamily: 'Arial',
                  fontWeight: 'bold',
                  color: '#333',
                  // fontSize: 18,
                }
              },
              {
                key: 'section8.1.5.12.2',
                text: '/ˌnevəðəˈles/',
                textStyle: {
                  fontFamily: 'Calibri',
                  color: '#999999',
                  // fontSize: 14,
                }
              }
            ],
            popWordList: [
              {
                key: 'section8.1.5.12.3',
                text: '释义',
                textStyle: {
                  fontFamily: 'STXihei',
                  color: '#333',
                  // fontSize: 14
                },
                content: [
                  {
                    key: 'section8.1.5.12.3.1',
                    text: '',
                    // textFlex:true,
                    textStyle: {
                    },
                    content: [
                      // 
                      {
                        key: 'section8.1.5.12.3.1.1',
                        text: 'despite what has just been said or referred to  ',
                        textStyle: {
                          fontFamily: 'Calibri',
                          color: '#333',
                          // fontSize: 13,
                          // lineHeight: 36
                        },
                      },
                      {
                        key: 'section8.1.5.12.3.1.2',
                        text: '不过，仍然；尽管如此',
                        textStyle: {
                          fontFamily: 'STXihei',
                          color: '#333',
                          // fontSize: 13,
                          // lineHeight: 36,
                        },
                      },
                    ]
                  },
                ]
              },
            ],
            textStyle: {
              fontFamily: 'Calibri', // 字体，本地配置的字体
            },
          },
          {
            key: 'section8.1.5.13', // *必填* 唯一标识
            category: 'text', // *必填* 内容类型 text：文本
            text: ', all festivals ', // *必填* 文本内容
            textStyle: {},
          },
          {
            key: 'section8.1.5.14', // *必填* 唯一标识
            category: 'popover', // *必填* 内容类型 text：文本
            text: 'make no difference', // *必填* 文本内容
            popTitle: '',
            popText: '',
            popWord: true,
            isPlay: false,
            word_url: require('@/assets/audio/2-7/10 make no difference.mp3'), // 单词音频,
            popWordTitle: [
              {
                key: 'section8.1.5.14.1',
                text: 'make no difference',
                textStyle: {
                  fontFamily: 'Arial',
                  fontWeight: 'bold',
                  color: '#333',
                  // fontSize: 18,
                }
              }
            ],
            popWordList: [
              {
                key: 'section8.1.5.14.3',
                text: '释义',
                textStyle: {
                  fontFamily: 'STXihei',
                  color: '#333',
                  // fontSize: 14
                },
                content: [
                  {
                    key: 'section8.1.5.14.3.1',
                    text: '',
                    // textFlex:true,
                    textStyle: {
                    },
                    content: [
                      // 
                      {
                        key: 'section8.1.5.14.3.1.2',
                        text: '没有影响，都一样',
                        textStyle: {
                          fontFamily: 'STXihei',
                          color: '#333',
                          // fontSize: 13,
                          // lineHeight: 36,
                        },
                      },
                    ]
                  },
                ]
              },
              {
                key: 'section8.1.5.14.4',
                text: '例句',
                textStyle: {
                  fontFamily: 'STXihei',
                  color: '#333',
                  // fontSize: 14
                },
                content: [
                  {
                    key: 'section8.1.5.14.4.1',
                    text: '',
                    textFlex:true,
                    textStyle: {
                    },
                    content: [
                      // 
                      {
                          key: 'section8.1.5.14.4.1.1',
                          text: 'e.g. ',
                          textStyle: {
                              fontFamily: 'Calibri',
                              color: '#333',
                              fontItalic: 1,
                          },

                      },
                      {
                          key: 'section8.1.5.14.4.1.2',
                          text: 'That will make no difference to him, whatever you may decide.',
                          textStyle: {
                              fontFamily: 'Calibri',
                              color: '#333',
                          },
                      },
                      {
                          key: 'section8.1.5.14.4.1.3',
                          text: '无论你做什么决定，对他都一样。',
                          textStyle: {
                              fontFamily: 'STXihei',
                              color: '#333',
                          },
                      },
                    ]
                  },
                ]
              },
            ],
            textStyle: {
              fontFamily: 'Calibri', // 字体，本地配置的字体
            },
          },
          {
            key: 'section8.1.5.15', // *必填* 唯一标识
            category: 'text', // *必填* 内容类型 text：文本
            text: ' to be celebrated for good wishes for happiness, health, luck, wealth and most important, family reunion.', // *必填* 文本内容
            textStyle: {},
          },
        ],
        textStyle: {
          fontFamily: 'Calibri', // 字体，本地配置的字体
          fontSize: 28, // 文字大小  默认：20
          lineHeight: 42, // 行高  默认：36
          textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
          // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
          // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
          // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
          // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
          color: '#333', // 文本颜色  默认：#00a8ac
          // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
      },
      {
        key: 'section8.1.6', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        isInTable: true,
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
          {
            key: 'section8.1.6.1', // *必填* 唯一标识
            category: 'text', // *必填* 内容类型 text：文本
            text: ' About eight traditional festivals are celebrated nationwide in China, namely, the Spring Festival, the ', // *必填* 文本内容
            textStyle: {},
          },
          {
            key: 'section8.1.6.2', // *必填* 唯一标识
            category: 'popover', // *必填* 内容类型 text：文本
            text: 'Lantern Festival', // *必填* 文本内容
            popTitle: '',
            popText: '',
            popWord: true,
            isPlay: false,
            word_url: require('@/assets/audio/2-7/12 Lantern Festival.mp3'), // 单词音频,
            popWordTitle: [
              {
                key: 'section8.1.6.2.1',
                text: 'Lantern Festival',
                textStyle: {
                  fontFamily: 'Arial',
                  fontWeight: 'bold',
                  color: '#333',
                  // fontSize: 18,
                }
              }
            ],
            popWordList: [
              {
                key: 'section8.1.6.2.3',
                text: '释义',
                textStyle: {
                  fontFamily: 'STXihei',
                  color: '#333',
                  // fontSize: 14
                },
                content: [
                  {
                    key: 'section8.1.6.2.3.1',
                    text: '',
                    // textFlex:true,
                    textStyle: {
                    },
                    content: [
                      // 
                      {
                        key: 'section8.1.6.2.3.1.1',
                        text: '元宵节',
                        textStyle: {
                          fontFamily: 'STXihei',
                          color: '#333',
                          // fontSize: 13,
                          // lineHeight: 36,
                        },
                      },
                    ]
                  },
                ]
              },
            ],
            textStyle: {
              fontFamily: 'Calibri', // 字体，本地配置的字体
            },
          },
          {
            key: 'section8.1.6.3', // *必填* 唯一标识
            category: 'text', // *必填* 内容类型 text：文本
            text: ', the Qingming Festival, the Dragon Boat Festival, the Qixi Festival, the Ghost Festival, the Mid-Autumn Festival and the Double Ninth Festival. Some other festivals are also celebrated in different areas such as the Laba Festival and the Winter ', // *必填* 文本内容
            textStyle: {},
          },
          {
            key: 'section8.1.6.4', // *必填* 唯一标识
            category: 'popover', // *必填* 内容类型 text：文本
            text: 'Solstice', // *必填* 文本内容
            popTitle: '',
            popText: '',
            popWord: true,
            isPlay: false,
            word_url: require('@/assets/audio/2-7/08 Solstice.mp3'), // 单词音频,
            popWordTitle: [
              {
                key: 'section8.1.6.4.1',
                text: 'solstice',
                textStyle: {
                  fontFamily: 'Arial',
                  fontWeight: 'bold',
                  color: '#333',
                  // fontSize: 18,
                }
              },
              {
                key: 'section8.1.6.4.2',
                text: '/ˈsɒlstɪs/',
                textStyle: {
                  fontFamily: 'Calibri',
                  color: '#999999',
                  // fontSize: 14,
                }
              }
            ],
            popWordList: [
              {
                key: 'section8.1.6.4.3',
                text: '释义',
                textStyle: {
                  fontFamily: 'STXihei',
                  color: '#333',
                  // fontSize: 14
                },
                content: [
                  {
                    key: 'section8.1.6.4.3.1',
                    text: '',
                    // textFlex:true,
                    textStyle: {
                    },
                    content: [
                      // 
                      {
                        key: 'section8.1.6.4.3.1.1',
                        text: '至，至点',
                        textStyle: {
                          fontFamily: 'STXihei',
                          color: '#333',
                          // fontSize: 13,
                          // lineHeight: 36,
                        },
                      },
                    ]
                  },
                  {
                    key: 'section8.1.6.4.3.2',
                    text: '',
                    // textFlex:true,
                    textStyle: {
                    },
                    content: [
                      // 
                      {
                        key: 'section8.1.6.4.3.2.1',
                        text: 'the summer/winter solstice  ',
                        textStyle: {
                          fontFamily: 'Calibri',
                          color: '#333',
                          // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                          // fontSize: 13,
                          // lineHeight: 36
                        },
                      },
                      {
                        key: 'section8.1.6.4.3.2.2',
                        text: '夏/冬至',
                        textStyle: {
                          fontFamily: 'STXihei',
                          color: '#333',
                          // fontSize: 13,
                          // lineHeight: 36,
                        },
                      },
                    ]
                  },
                ]
              },
            ],
            textStyle: {
              fontFamily: 'Calibri', // 字体，本地配置的字体
            },
          },
          {
            key: 'section8.1.6.5', // *必填* 唯一标识
            category: 'text', // *必填* 内容类型 text：文本
            text: ' Festival. ', // *必填* 文本内容
            textStyle: {},
          },
          {
            key: 'section8.1.6.6', // *必填* 唯一标识
            category: 'popover', // *必填* 内容类型 text：文本
            text: 'In addition', // *必填* 文本内容
            popTitle: '',
            popText: '',
            popWord: true,
            isPlay: false,
            word_url: require('@/assets/audio/2-7/11 in addition.mp3'), // 单词音频,
            popWordTitle: [
              {
                key: 'section8.1.6.6.1',
                text: 'In addition',
                textStyle: {
                  fontFamily: 'Arial',
                  fontWeight: 'bold',
                  color: '#333',
                  // fontSize: 18,
                }
              }
            ],
            popWordList: [
              {
                key: 'section8.1.6.6.3',
                text: '释义',
                textStyle: {
                  fontFamily: 'STXihei',
                  color: '#333',
                  // fontSize: 14
                },
                content: [
                  {
                    key: 'section8.1.6.6.3.1',
                    text: '',
                    // textFlex:true,
                    textStyle: {
                    },
                    content: [
                      // 
                      {
                        key: 'section8.1.6.6.3.1.1',
                        text: '此外，另外，还有。通常放在句首，后面加逗号再接一个句子，以用來补充和上一句话相关的事情。',
                        textStyle: {
                          fontFamily: 'STXihei',
                          color: '#333',
                          // fontSize: 13,
                          // lineHeight: 36,
                        },
                      },
                    ]
                  },
                ]
              },
              
              {
                key: 'section8.1.6.6.4',
                text: '例句',
                textStyle: {
                  fontFamily: 'STXihei',
                  color: '#333',
                  // fontSize: 14
                },
                content: [
                  {
                    key: 'section8.1.6.6.4.1',
                    text: '',
                    textFlex:true,
                    textStyle: {
                    },
                    content: [
                      // 
                      {
                          key: 'section8.1.6.6.4.1.1',
                          text: 'e.g. ',
                          textStyle: {
                              fontFamily: 'Calibri',
                              color: '#333',
                              fontItalic: 1,
                          },

                      },
                      {
                          key: 'section8.1.6.6.4.1.2',
                          text: 'In addition, they do not match very much. ',
                          textStyle: {
                              fontFamily: 'Calibri',
                              color: '#333',
                          },
                      },
                      {
                          key: 'section8.1.6.6.4.1.3',
                          text: '除此之外，他们两人并不十分般配。',
                          textStyle: {
                              fontFamily: 'STXihei',
                              color: '#333',
                          },
                      },
                    ]
                  },
                ]
              },
              {
                key: 'section8.1.6.6.5',
                text: '词以类记',
                textStyle: {
                  fontFamily: 'STXihei',
                  color: '#333',
                  // fontSize: 14
                },
                content: [
                  {
                    key: 'section8.1.6.6.5.1',
                    text: '',
                    textFlex:true,
                    textStyle: {
                    },
                    content: [
                      // 
                      {
                          key: 'section8.1.6.6.5.1.1',
                          text: 'e.g. ',
                          textStyle: {
                              fontFamily: 'Calibri',
                              color: '#333',
                              fontItalic: 1,
                          },

                      },
                      {
                          key: 'section8.1.6.6.5.1.2',
                          text: 'We play football in addition to basketball.',
                          textStyle: {
                              fontFamily: 'Calibri',
                              color: '#333',
                          },
                      },
                      {
                          key: 'section8.1.6.6.5.1.3',
                          text: '除了篮球外，我们还踢足球。',
                          textStyle: {
                              fontFamily: 'STXihei',
                              color: '#333',
                          },
                      },
                      {
                          key: 'section8.1.6.6.5.1.4',
                          text: 'In addition to English, he has to study a second foreign language.',
                          textStyle: {
                              fontFamily: 'Calibri',
                              color: '#333',
                          },
                      },
                      {
                          key: 'section8.1.6.6.5.1.5',
                          text: '除英语外，他还得学第二外语。',
                          textStyle: {
                              fontFamily: 'STXihei',
                              color: '#333',
                          },
                      },
                    ]
                  },
                ]
              },
            ],
            textStyle: {
              fontFamily: 'Calibri', // 字体，本地配置的字体
            },
          },
          {
            key: 'section8.1.6.7', // *必填* 唯一标识
            category: 'text', // *必填* 内容类型 text：文本
            text: ', unique festivals are celebrated among different ', // *必填* 文本内容
            textStyle: {},
          },
          {
            key: 'section8.1.6.8', // *必填* 唯一标识
            category: 'popover', // *必填* 内容类型 text：文本
            text: 'ethnic', // *必填* 文本内容
            popTitle: '',
            popText: '',
            popWord: true,
            isPlay: false,
            word_url: require('@/assets/audio/2-7/09 ethnic.mp3'), // 单词音频,
            popWordTitle: [
              {
                key: 'section8.1.6.8.1',
                text: 'ethnic',
                textStyle: {
                  fontFamily: 'Arial',
                  fontWeight: 'bold',
                  color: '#333',
                  // fontSize: 18,
                }
              },
              {
                key: 'section8.1.6.8.2',
                text: '/ˈeθnɪk/',
                textStyle: {
                  fontFamily: 'Calibri',
                  color: '#999999',
                  // fontSize: 14,
                }
              }
            ],
            popWordList: [
              {
                key: 'section8.1.6.8.3',
                text: '释义',
                textStyle: {
                  fontFamily: 'STXihei',
                  color: '#333',
                  // fontSize: 14
                },
                content: [
                  {
                    key: 'section8.1.6.8.3.1',
                    text: '',
                    // textFlex:true,
                    textStyle: {
                    },
                    content: [
                      // 
                      {
                        key: 'section8.1.6.8.3.1.1',
                        text: 'relating or belonging to a group of people who can be seen as distinct (= different) because they have a shared culture, tradition, language, history, etc.  ',
                        textStyle: {
                          fontFamily: 'Calibri',
                          color: '#333',
                          // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                          // fontSize: 13,
                          // lineHeight: 36
                        },
                      },
                      {
                        key: 'section8.1.6.8.3.1.2',
                        text: '民族的；种族的',
                        textStyle: {
                          fontFamily: 'STXihei',
                          color: '#333',
                          // fontSize: 13,
                          // lineHeight: 36,
                        },
                      },
                    ]
                  },
                ]
              },
            ],
            textStyle: {
              fontFamily: 'Calibri', // 字体，本地配置的字体
            },
          },
          {
            key: 'section8.1.6.9', // *必填* 唯一标识
            category: 'text', // *必填* 内容类型 text：文本
            text: '  groups, e.g. Torch Festival among Yi people, Lusheng Festival among Miao people, Water-sprinkling Festival among Dai people and the like.', // *必填* 文本内容
            textStyle: {},
          },
        ],
        textStyle: {
          fontFamily: 'Calibri', // 字体，本地配置的字体
          fontSize: 28, // 文字大小  默认：20
          lineHeight: 42, // 行高  默认：36
          textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
          // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
          // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
          // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
          // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
          color: '#333', // 文本颜色  默认：#00a8ac
          // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
      },
    ],
  },
]
export default content